<div class="create-query-container ant-advanced-search-form" nzCompact>
    <div class="form-row bg-dark-blue text-white">
        <span class="span-header">Query Details</span>
      </div>
    <br/>
    <div class="row form-group">
      <div class="col-md-2">
        <label>Reference Number</label>
      </div>
      <div class="col-md-3">
        <input nz-input value="{{queryModel.Query_Reference_Number}}" style="font-weight: bold;" name="QueryReferenceNumber"
          type="text" class="form-control" disabled />
      </div>
      <div class="col-md-3 col-md-push-1">
        <label>Date of Request</label>
      </div>
      <div class="col-md-3">
        <input nz-input value="{{queryModel.Created_Date | date:'dd-MMM-yyyy'}}" name="CreatedDate" type="text"
          class="form-control" disabled />
      </div>
    </div>
  
    <div class="row form-group">
      <div class="col-md-2">
        <label>Subject</label>
      </div>
      <div class="col-md-3">
        <input nz-input name="Subject" 
        type="text" 
        class="form-control" disabled      
        value="{{queryModel.Subject}}" title="{{queryModel.Subject}}" />       
      </div>
      <div class="col-md-3 col-md-push-1">
        <label>Request Status</label>
      </div>
      <div class="col-md-3">
        <input nz-input value="{{queryModel.PartnerQueryStatus}}" style="font-weight: bold;" name="PartnerQueryStatus" type="text"
          class="form-control" disabled />
      </div>
    </div>
  
    <div class="row form-group">
      <div class="col-md-2">
        <label>Priority</label>
      </div>
      <div class="col-md-3">
        <input nz-input value="{{queryModel.QueryDetail.PriorityLevel}}" title="{{queryModel.QueryDetail.PriorityLevel}}" 
          name="PriorityLevel" type="text" class="form-control" disabled />
      </div>
      <div class="col-md-3">
        <label>Confidential</label>
      </div>
      <div class="col-md-3">
        <input nz-input type="checkbox" name="Partner_Confidential" class="chckbx-Confidential"
            [checked]="queryModel.QueryDetail.Is_Confidential" onclick="return false;" />
      </div>
    </div>
  
    <div class="row form-group">
        <div class="col-md-2">
          <label>CC Emails</label>
        </div>
        <div class="col-md-3" >
          <textarea nz-input type="text" rows="3" class="form-control" name="CCEmails"  value="{{queryModel.QueryDetail.CCEmails}}" 
          disabled ></textarea>
        </div>        
          <div class="col-md-3 col-md-push-1" *ngIf="queryModel.CanViewPrevsQueryDtls">
            <label>Query Type</label>
          </div>
          <div class="col-md-3" *ngIf="queryModel.CanViewPrevsQueryDtls">
              <input nz-input value="Re-Opened" name="Query Type" type="text" style="font-weight: bold;" class="form-control" disabled />
          </div>
        
    </div>
    <div class="form-row bg-dark-blue text-white">
        <span class="span-header">Requestor Details</span>
      </div>
    <br/>
    <div class="row form-group">
      <div class="col-md-2">
        <label>Requestor Name</label>
      </div>
      <div class="col-md-3">
        <input nz-input value="{{queryModel.RequestorDetail.User_Name}}" name="RequestorDetail.User_Name" type="text"
          class="form-control" disabled />
      </div>
      <div class="col-md-3 col-md-push-1">
        <label>Requestor Email</label>
      </div>
      <div class="col-md-3">
        <input nz-input value="{{queryModel.RequestorDetail.Email}}" name="RequestorDetail.Email" type="text" class="form-control"
          disabled />
      </div>
    </div>
  
    <div class="row form-group">
      <div class="col-md-2">
        <label>Company:</label>
      </div>
      <div class="col-md-3">
        <input nz-input value="{{queryModel.QueryDetail.CompanyName}}" name="RequestorDetail.CompanyName" type="text"
          class="form-control" disabled />
      </div>
      <div class="col-md-3 col-md-push-1">
          <label>Block</label>
      </div>
      <div class="col-md-3">
          <input nz-input value="{{queryModel.QueryDetail.Block}}" name="queryModel.QueryDetail.Block" type="text"
          class="form-control" disabled />
      </div>
    </div>
  
    <div class="form-row bg-dark-blue text-white">
        <span class="span-header">Clarification Request Details</span>
      </div>
    <br/>
    
    <div class="row form-group" *ngIf="queryModel.CanViewPrevsQueryDtls">
      <div class="col-md-2">
        <!-- <label>Block</label> -->
      </div>
      <div class="col-md-3">
        <!-- <input value="{{queryModel.QueryDetail.Block}}" name="queryModel.QueryDetail.Block" type="text"
          class="form-control" disabled /> -->
      </div>
      <div class="col-md-3 col-md-push-1">
      </div>
      <div class="col-md-3" >
        <button nz-button nzType="primary" routerLink="/clarification-query/view-previous-query-details/{{ queryCode }}">
          Previous Query Resolution Details
        </button>
        
      </div>
    </div>
  
    <div class="row form-group">
      <div class="col-md-2">
        <label>Department</label>
      </div>
      <div class="col-md-3">
        <input nz-input value="{{queryModel.QueryDetail.Department}}" title="{{queryModel.QueryDetail.Department}}"
          name="queryModel.QueryDetail.Department" type="text" class="form-control" disabled />
      </div>
      <div class="col-md-3 col-md-push-1">
        <label>Sub Department</label>
      </div>
      <div class="col-md-3">
        <input nz-input value="{{queryModel.QueryDetail.SubDepartment}}" title="{{queryModel.QueryDetail.SubDepartment}}"
          name="queryModel.QueryDetail.SubDepartment" type="text" class="form-control" disabled />
      </div>
    </div>
  
    <div class="row form-group">
      <div class="col-md-2">
        <label>CC</label>
      </div>
      <div class="col-md-3" >
        
        <nz-select id="cc" [(ngModel)]="selectedCCUsers" nzMode="multiple" nzPlaceHolder="No CC Users" disabled
              style="width: 100%;">
            <nz-option *ngFor="let item of partnerUserMaster" [nzLabel]="item.label"
                [nzValue]="item.value"></nz-option>
        </nz-select>
      </div>
    </div>
  
    <div class="row form-group">
      <div class="col-md-2 required">
        <label>Partner Comments </label>
      </div>
      <div class="col-md-6">
        <textarea nz-input rows="3" ngModel="{{queryModel.QueryDetail.Partner_Comment}}" name="Partner_Comment" type="text"
          disabled class="form-control"></textarea>
      </div>
      <div class="col-md-3">
        <div>
            <label> Attachment count - {{partnerUploadedAttachmtCnt}}</label>
          </div>
        <button *ngIf="partnerUploadedAttachmtCnt>0" (click)="viewAttachments(true)" nz-button nzType="primary">
          View Attachments
        </button>
        
      </div>
    </div>
  
    <div *ngIf="queryModel && canViewResponseDetails">
      <div class="form-row bg-dark-blue text-white">
        <span class="span-header">Requestor Details</span>
      </div>
    <br/>
      <div class="row form-group" *ngIf="!canViewDeletedComment">
        <div class="col-md-2">
          <label>Resolution Comment</label>
        </div>
        <div class="col-md-6">
          <textarea nz-input rows="3" ngModel="{{queryModel.QueryDetail.Resolution_Comment}}" name="Resolution_Comment" type="text"
            disabled class="form-control"></textarea>
        </div>
        <div class="col-md-3">
          <button (click)="viewAttachments(false)" nz-button nzType="primary">
            View Attachments
          </button>
          <div>
            <label> Attachment count - {{internalUserUploadedAttachmtCnt}}</label>
          </div>
        </div>
      </div>
      <div class="row form-group" *ngIf="canViewDeletedComment">
        <div class="col-md-2">
          <label>Deleted Comment</label>
        </div>
        <div class="col-md-6">
          <textarea nz-input rows="3" ngModel="{{queryModel.Delete_Comment}}" name="Delete_Comment" type="text" disabled
            class="form-control"></textarea>
        </div>
      </div>
    </div>
    
    <div class="row form-group">
      <div class="col-md-6 col-md-push-2">        
        <button nz-button nzType="primary" [routerLink]="'/clarification-query/my-query'">Back</button>
      </div>
    </div>
    <br>
    
  </div>

  <ng-template #customTemplate>
    <div>
      <h3>Custom Content1</h3>
      <p>This is a custom template passed to the modal1.</p>
    </div>
  </ng-template>